export const formatDateToBR = (dateString: string | undefined) => {
  if (!dateString) {
    return '';
  }

  const date = new Date(`${dateString}T00:00:00`);
  return date.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
};
